export const products = [
  // FERMETURES
  {
    id: 1,
    slug: "fermeture-chaine-continue-5",
    name: "Fermeture chaine continue n°5",
    category: "fermetures",
    image: "/images/Femeturech5.jpeg",
    description: "Fermeture chaine continue n°5 destinée aux professionnels du textile et de la confection.",
    colors: [
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Gris clair", code: "#f1f1f1", text: "#000000" },
      { name: "Gris foncé", code: "#6c757d", text: "#ffffff" },
      { name: "Marron", code: "#8b4513", text: "#ffffff" },
      { name: "Rouge", code: "#ff0000", text: "#ffffff" },
      { name: "Bleu", code: "#007bff", text: "#ffffff" },
      { name: "Vert", code: "#28a745", text: "#ffffff" },
      { name: "Jaune", code: "#ffc107", text: "#000000" },
      { name: "Orange", code: "#fd7e14", text: "#000000" },
      { name: "Rose", code: "#e83e8c", text: "#ffffff" },
    ],
    sizes: ["100y"],
    featured: false,
  },
  {
    id: 2,
    slug: "fermeture-chaine-continue-3",
    name: "Fermeture chaine continue n°3",
    category: "fermetures",
    image: "/images/fch3.jpg",
    description: "Fermeture chaine continue n°3 pour vêtements et accessoires.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
    ],
    sizes: ["200y"],
    featured: false,
  },
  {
    id: 3,
    slug: "curseur-5-lux",
    name: "Curseur lux 5",
    category: "fermetures",
    image: "/images/curseurlux.jpg",
    description: "Curseur lux 5 pour fermetures à glissière.",
    colors: [
      { name: "Argent", code: "#C0C0C0", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 4,
    slug: "curseur-5",
    name: "Curseur 5",
    category: "fermetures",
    image: "/images/curseur5.jpg",
    description: "Curseur standard 5 pour fermetures à glissière.",
    colors: [
      { name: "Argent", code: "#C0C0C0", text: "#000000" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 5,
    slug: "curseur-3-lux",
    name: "Curseur lux 3",
    category: "fermetures",
    image: "/images/curseurlux.jpg",
    description: "Curseur lux 3 pour fermetures à glissière.",
    colors: [
      { name: "Argent", code: "#C0C0C0", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 6,
    slug: "curseur-3",
    name: "Curseur 3",
    category: "fermetures",
    image: "/images/curseur5.jpg",
    description: "Curseur standard 3 pour fermetures à glissière.",
    colors: [
      { name: "Argent", code: "#C0C0C0", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 7,
    slug: "fermeture-ouvrable-120",
    name: "Fermeture ouvrables",
    category: "fermetures",
    image: "/images/Fouv.jpg",
    description: "Fermeture ouvrable 120cm pour vêtements.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["120cm"],
    featured: false,
  },
  {
    id: 8,
    slug: "fermeture-ouvrable-80",
    name: "Fermeture ouvrables",
    category: "fermetures",
    image: "/images/Fouv.jpg",
    description: "Fermeture ouvrable 80cm pour vêtements.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Bleu marine", code: "#0B1C2D", text: "#ffffff" },
    ],
    sizes: ["80cm"],
    featured: false,
  },
  {
    id: 9,
    slug: "fermeture-ouvrable-75",
    name: "Fermeture ouvrables",
    category: "fermetures",
    image: "/images/Fouv.jpg",
    description: "Fermeture ouvrable 75cm pour vêtements.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Bleu marine", code: "#0B1C2D", text: "#ffffff" },
    ],
    sizes: ["75cm"],
    featured: false,
  },
  {
    id: 10,
    slug: "fermeture-glissiere-60",
    name: "Fermeture à glissière",
    category: "fermetures",
    image: "/images/Fermeture.jpg",
    description: "Fermeture à glissière 60cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
      { name: "Marron", code: "#8b4513", text: "#ffffff" },
    ],
    sizes: ["60cm"],
    featured: false,
  },
  {
    id: 11,
    slug: "fermeture-glissiere-50",
    name: "Fermeture à glissière",
    category: "fermetures",
    image: "/images/Fermeture.jpg",
    description: "Fermeture à glissière 50cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
      { name: "Gris foncé", code: "#6c757d", text: "#ffffff" },
      { name: "Marron", code: "#8b4513", text: "#ffffff" },
    ],
    sizes: ["50cm"],
    featured: false,
  },
  {
    id: 12,
    slug: "fermeture-glissiere-40",
    name: "Fermeture à glissière",
    category: "fermetures",
    image: "/images/Fermeture.jpg",
    description: "Fermeture à glissière 40cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["40cm"],
    featured: false,
  },
  {
    id: 13,
    slug: "fermeture-glissiere-20",
    name: "Fermeture à glissière",
    category: "fermetures",
    image: "/images/F20.jpg",
    description: "Fermeture à glissière 20cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["20cm"],
    featured: false,
  },
  {
    id: 14,
    slug: "fermeture-invisible-60",
    name: "Fermeture à glissière invisible",
    category: "fermetures",
    image: "/images/finvisible.jpg",
    description: "Fermeture à glissière invisible 60cm.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["60cm"],
    featured: false,
  },
  {
    id: 15,
    slug: "fermeture-invisible-20",
    name: "Fermeture à glissière invisible",
    category: "fermetures",
    image: "/images/finvisible.jpg",
    description: "Fermeture à glissière invisible 20cm.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["20cm"],
    featured: false,
  },

  // ELASTIQUE
  {
    id: 16,
    slug: "elastique-0-5",
    name: "Élastique 0,5cm",
    category: "elastiques",
    image: "/images/Elastique5.jpg",
    description: "Élastique 0,5cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 17,
    slug: "elastique-0-8",
    name: "Élastique 0,8cm",
    category: "elastiques",
    image: "/images/Elastique8mm.jpg",
    description: "Élastique 0,8cm pour confection.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 18,
    slug: "elastique-1",
    name: "Élastique 1cm",
    category: "elastiques",
    image: "/images/elastique1cm.jpeg",
    description: "Élastique 1cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 19,
    slug: "elastique-1-2",
    name: "Élastique 1,2cm",
    category: "elastiques",
    image: "/images/elastique12mm.jpeg",
    description: "Élastique 1,2cm pour confection.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 20,
    slug: "elastique-1-4",
    name: "Élastique 1,4cm",
    category: "elastiques",
    image: "/images/elastique14mm.jpeg",
    description: "Élastique 1,4cm pour confection.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },

  // FIL
  {
    id: 21,
    slug: "fil-cone",
    name: "Fil à coudre — cône",
    category: "fils",
    image: "/images/filcones.jpg",
    description: "Fil à coudre professionnel en cône disponible dans plusieurs coloris.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Gray", code: "#A9A9A9" },
      { name: "Blue", code: "#483D8B" },
      { name: "Green", code: "#8FBC8F" },
      { name: "Brown", code: "#5C4033" },
      { name: "Red", code: "#8B0000" },
      { name: "Salmon", code: "#E9967A" },
      { name: "Violet", code: "#9400D3" },
      { name: "Raspberry", code: "#872657" },
      { name: "Coral", code: "#CD5B45" },
      { name: "Turquoise", code: "#00CED1" },
      { name: "Khaki", code: "#BDB76B" },
      { name: "Orange", code: "#FF8C00" },
      { name: "Purple", code: "#301934" },
      { name: "Burgundy", code: "#800020" },
      { name: "Olive", code: "#556B2F" },
    ],
    featured: true,
  },
  {
    id: 22,
    slug: "fil-mousse",
    name: "Fil mousse",
    category: "fils",
    image: "/images/filmousse.jpg",
    description: "Fil mousse pour surjet et finitions.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Gray", code: "#A9A9A9" },
      { name: "Raspberry", code: "#872657" },
      { name: "Orange", code: "#FF8C00" },
      { name: "Jaune", code: "#ffc107", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 23,
    slug: "fil-bobine",
    name: "Fil à coudre — bobine",
    category: "fils",
    image: "/images/tibino.jpg",
    description: "Fil à coudre en bobine disponible dans plusieurs coloris.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Gray", code: "#A9A9A9" },
      { name: "Blue", code: "#483D8B" },
      { name: "Green", code: "#8FBC8F" },
      { name: "Brown", code: "#5C4033" },
      { name: "Red", code: "#8B0000" },
      { name: "Salmon", code: "#E9967A" },
      { name: "Violet", code: "#9400D3" },
      { name: "Raspberry", code: "#872657" },
      { name: "Coral", code: "#CD5B45" },
      { name: "Turquoise", code: "#00CED1" },
      { name: "Khaki", code: "#BDB76B" },
      { name: "Orange", code: "#FF8C00" },
      { name: "Purple", code: "#301934" },
      { name: "Burgundy", code: "#800020" },
      { name: "Olive", code: "#556B2F" },
    ],
    featured: false,
  },
  {
    id: 24,
    slug: "fil-tapissier",
    name: "Fil tapissier",
    category: "fils",
    image: "/images/capitonage.jpg",
    description: "Fil tapissier pour capitonnage et travaux d'ameublement.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["18", "24"],
    featured: false,
  },
  {
    id: 25,
    slug: "fil-transparent",
    name: "Fil transparent",
    category: "fils",
    image: "/images/filinvisible.jpg",
    description: "Fil transparent pour couture invisible.",
    sizes: ["0,14"],
    featured: false,
  },

  // DIVERS
  {
    id: 26,
    slug: "epingle-arabe",
    name: "Épingle arabe",
    category: "divers",
    image: "/images/Epingle.jpeg",
    description: "Épingle arabe pour couture et travaux manuels.",
    sizes: ["moyen"],
    featured: false,
  },
  {
    id: 27,
    slug: "aiguille-machine-domestique",
    name: "Aiguille machine domestique",
    category: "divers",
    image: "/images/aiguille.jpg",
    description: "Aiguille pour machine à coudre domestique.",
    sizes: ["90/14", "90/16"],
    featured: false,
  },
  {
    id: 28,
    slug: "pistolet-etiquette",
    name: "Pistolet étiquette",
    category: "divers",
    image: "/images/Pistolet.jpg",
    description: "Pistolet à étiquettes pour vêtements.",
    sizes: ["Standard"],
    featured: false,
  },
  {
    id: 29,
    slug: "aiguille-pistolet",
    name: "Aiguille pistolet",
    category: "divers",
    image: "/images/aiguillepistolet.jpg",
    description: "Aiguille pour pistolet à étiquettes.",
    sizes: ["Standard"],
    featured: false,
  },
  {
    id: 30,
    slug: "attache-pistolet-etiquette",
    name: "Attache pistolet étiquette",
    category: "divers",
    image: "/images/attachepistolet.jpg",
    description: "Attache pour pistolet à étiquettes.",
    sizes: ["1cm", "3cm", "5cm"],
    featured: false,
  },
  {
    id: 31,
    slug: "attache-etiquette-main",
    name: "Attache étiquette à main",
    category: "divers",
    image: "/images/attachemain.jpg",
    description: "Attache étiquette à main.",
    sizes: ["7cm"],
    featured: false,
  },
  {
    id: 32,
    slug: "silicone",
    name: "Silicone",
    category: "divers",
    image: "/images/silicone.jpg",
    description: "Bâton de silicone pour pistolet à colle.",
    sizes: ["11,2mm", "7,2mm"],
    featured: false,
  },
  {
    id: 33,
    slug: "pistolet-colle",
    name: "Pistolet colle",
    category: "divers",
    image: "/images/pistoletcolle.jpg",
    description: "Pistolet à colle pour travaux manuels.",
    sizes: ["11,2mm", "7,2mm"],
    featured: false,
  },
  {
    id: 34,
    slug: "coupe-fil-plastique",
    name: "Coupe fil plastique",
    category: "divers",
    image: "/images/coupefil.jpg",
    description: "Coupe-fil plastique pour couture.",
    colors: [
      { name: "Rouge", code: "#ff0000", text: "#ffffff" },
    ],
    featured: false,
  },
  {
    id: 35,
    slug: "coupe-fil-metalique",
    name: "Coupe fil métallique",
    category: "divers",
    image: "/images/coupefilmetal.jpg",
    description: "Coupe-fil métallique pour couture.",
    colors: [
      { name: "Bronze foncé", code: "#8C6239", text: "#ffffff" },
    ],
    featured: false,
  },
  {
    id: 36,
    slug: "agraphe-pantalon",
    name: "Agraphe pantalon",
    category: "divers",
    image: "/images/Aggraphe.jpg",
    description: "Agraphe pour pantalon.",
    featured: false,
  },
  {
    id: 37,
    slug: "roulette-bois",
    name: "Roulette bois",
    category: "divers",
    image: "/images/roulette.jpg",
    description: "Roulette en bois pour couture.",
    colors: [
      { name: "Marron", code: "#8b4513", text: "#ffffff" },
    ],
    featured: false,
  },
  {
    id: 38,
    slug: "thermocollant-double-face",
    name: "Thermocollant double face",
    category: "divers",
    image: "/images/ourlet.jpg",
    description: "Thermocollant double face pour ourlets.",
    sizes: ["10mm", "20mm", "25mm"],
    featured: false,
  },
  {
    id: 39,
    slug: "craie-tailleur-triangles",
    name: "Craie tailleur triangles",
    category: "divers",
    image: "/images/cretriangle.jpg",
    description: "Craie de tailleur en forme de triangles.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000000" },
      { name: "Rouge", code: "#ff0000", text: "#ffffff" },
      { name: "Bleu", code: "#007bff", text: "#ffffff" },
      { name: "Jaune", code: "#ffc107", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 40,
    slug: "craie-tailleur-rectangle",
    name: "Craie tailleur rectangle",
    category: "divers",
    image: "/images/Crerectangle.jpg",
    description: "Craie de tailleur en forme de rectangle.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000000" },
      { name: "Rouge", code: "#ff0000", text: "#ffffff" },
      { name: "Bleu", code: "#007bff", text: "#ffffff" },
      { name: "Jaune", code: "#ffc107", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 41,
    slug: "epaulette",
    name: "Epaulette",
    category: "divers",
    image: "/images/epaulette.jpg",
    description: "Épaulette pour vêtements.",
    colors: [
      { name: "Gris foncé", code: "#6c757d", text: "#ffffff" },
    ],
    featured: false,
  },
  {
    id: 42,
    slug: "hausse-de-ceinture",
    name: "Hausse de ceinture",
    category: "divers",
    image: "/images/grogain.jpg",
    description: "Hausse de ceinture pour pantalons.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },

  // ACCESSOIRES RIDEAUX
  {
    id: 43,
    slug: "tresse-2-poches",
    name: "Tresse 2 poches",
    category: "accessoires-rideaux",
    image: "/images/Tresse7cm.webp",
    description: "Tresse 2 poches pour rideaux.",
    sizes: ["7cm"],
    featured: false,
  },
  {
    id: 44,
    slug: "tresse-8-anneaux",
    name: "Tresse 8 anneaux",
    category: "accessoires-rideaux",
    image: "/images/Tresse8.jpeg",
    description: "Tresse 8 anneaux pour rideaux.",
    colors: [
      { name: "Argent", code: "#C0C0C0", text: "#000000" },
      { name: "Doré", code: "#D4AF37", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 45,
    slug: "tresse-passante-invisible-10",
    name: "Tresse passante invisible",
    category: "accessoires-rideaux",
    image: "/images/Tresse10.jpeg",
    description: "Tresse passante invisible 10cm pour rideaux.",
    sizes: ["10cm"],
    featured: false,
  },
  {
    id: 46,
    slug: "oeillette-rideaux-metal-42",
    name: "Œillette rideaux métal",
    category: "accessoires-rideaux",
    image: "/images/oeillets.jpg",
    description: "Œillette métal 42mm pour rideaux.",
    colors: [
      { name: "Argent", code: "#C0C0C0", text: "#000000" },
      { name: "Doré", code: "#D4AF37", text: "#000000" },
      { name: "Bronze foncé", code: "#8C6239", text: "#ffffff" },
    ],
    sizes: ["42mm"],
    featured: false,
  },

  // BOUTONS
  {
    id: 47,
    slug: "boutons-recouvrir-aluminium",
    name: "Boutons recouvrir aluminium",
    category: "boutons",
    image: "/images/Boutonsrecouvrir.jpeg",
    description: "Boutons à recouvrir en aluminium.",
    sizes: ["12mm", "14mm", "16mm", "18mm", "20mm", "22mm", "24mm", "26mm", "28mm", "32mm", "36mm", "40mm", "45mm"],
    featured: false,
  },
  {
    id: 48,
    slug: "boutons-recouvrir-boule",
    name: "Boutons recouvrir boule",
    category: "boutons",
    image: "/images/boutonsboule.jpeg",
    description: "Boutons à recouvrir en forme de boule.",
    sizes: ["12mm", "14mm", "16mm"],
    featured: false,
  },
  {
    id: 49,
    slug: "boutons-recouvrir-acier-queue",
    name: "Boutons recouvrir acier avec queue",
    category: "boutons",
    image: "/images/Boutonacier.jpg",
    description: "Boutons à recouvrir en acier avec queue.",
    sizes: ["16mm", "18mm", "20mm", "22mm", "24mm"],
    featured: false,
  },
  {
    id: 50,
    slug: "machine-pression-recouvrir",
    name: "Machine pression / recouvrir",
    category: "boutons",
    image: "/images/machine.jpeg",
    description: "Machine pour boutons pression et à recouvrir.",
    colors: [
      { name: "Vert", code: "#28a745", text: "#ffffff" },
    ],
    featured: false,
  },

  // CISEAUX
  {
    id: 51,
    slug: "ciseaux-zigzag",
    name: "Ciseaux zigzag",
    category: "ciseaux",
    image: "/images/Ciseauzigzag.jpeg",
    description: "Ciseaux zigzag pour couture.",
    sizes: ["8in"],
    featured: false,
  },
  {
    id: 52,
    slug: "ciseaux-metal",
    name: "Ciseaux métal",
    category: "ciseaux",
    image: "/images/ciseau8.jpg",
    description: "Ciseaux métal pour couture.",
    sizes: ["8", "10", "12"],
    featured: false,
  },

  // ACCESSOIRES TAPISSERIER
  {
    id: 53,
    slug: "clous",
    name: "Clous",
    category: "accessoires-tapissier",
    image: "/images/Cloust50.webp",
    description: "Clous pour tapisserie.",
    sizes: ["50mm"],
    featured: false,
  },
  {
    id: 54,
    slug: "graphe",
    name: "Graphe",
    category: "accessoires-tapissier",
    image: "/images/Graphe10.jpg",
    description: "Agraphes pour tapisserie.",
    sizes: ["10mm"],
    featured: false,
  },

  // VELCRO
  {
    id: 55,
    slug: "velcro-2",
    name: "Velcro 2cm",
    category: "velcro",
    image: "/images/Velcro2cm.jpeg",
    description: "Velcro 2cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 56,
    slug: "velcro-4",
    name: "Velcro 4cm",
    category: "velcro",
    image: "/images/velcro4.jpg",
    description: "Velcro 4cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 57,
    slug: "velcro-5",
    name: "Velcro 5cm",
    category: "velcro",
    image: "/images/velcro5.jpg",
    description: "Velcro 5cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: true,
  },
  {
    id: 58,
    slug: "velcro-10",
    name: "Velcro 10cm",
    category: "velcro",
    image: "/images/velcro10.jpg",
    description: "Velcro 10cm pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },

  // TISSUS
  {
    id: 59,
    slug: "toile-collant-polyester",
    name: "Toile collant polyester",
    category: "tissus",
    image: "/images/toilepoly.jpeg",
    description: "Toile collant en polyester pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 60,
    slug: "toile-collant-polycoton",
    name: "Toile collant polycoton",
    category: "tissus",
    image: "/images/Toilepolycoton.jpg",
    description: "Toile collant en polycoton pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 61,
    slug: "viseline-collant",
    name: "Viseline collant",
    category: "tissus",
    image: "/images/viseline.jpg",
    description: "Viseline collant pour entoilage.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    sizes: ["1020Hf(20g+5g)", "1025Hf(30+10g)"],
    featured: false,
  },
  {
    id: 62,
    slug: "polyester-2m40",
    name: "Polyester 2m40",
    category: "tissus",
    image: "/images/pongee.jpg",
    description: "Tissu polyester 2m40 de large.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
    ],
    featured: false,
  },
  {
    id: 63,
    slug: "fond-de-poche",
    name: "Fond de poche",
    category: "tissus",
    image: "/images/poche.jpg",
    description: "Tissu pour fond de poche.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 64,
    slug: "satin",
    name: "Satin",
    category: "tissus",
    image: "/images/satin.jpg",
    description: "Tissu satin pour confection.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
      { name: "Rouge", code: "#c70909" },
      { name: "Vert", code: "#28a745", text: "#ffffff" },
      { name: "Jaune", code: "#ffc107", text: "#000000" },
      { name: "Rose", code: "#e83e8c", text: "#ffffff" },
    ],
    featured: false,
  },
  {
    id: 65,
    slug: "Triplure",
    name: "Triplure",
    category: "tissus",
    image: "/images/treplure.jpg",
    description: "Triplure pour renfort de vêtements.",
    colors: [
      { name: "Blanc", code: "#ffffff", text: "#000" },
    ],
    featured: false,
  },
  {
    id: 66,
    slug: "Doublure",
    name: "Doublure",
    category: "tissus",
    image: "/images/doublure.jpg",
    description: "Tissu doublure pour vêtements.",
    colors: [
      { name: "Noir", code: "#000000" },
      { name: "Blanc", code: "#ffffff", text: "#000" },
      { name: "Rouge", code: "#c70909" },
      { name: "Vert", code: "#28a745", text: "#ffffff" },
      { name: "Vert Militaire", code: "#556B2F" },
      { name: "Marron", code: "#8b4513", text: "#ffffff" },
      { name: "Beige foncé", code: "#D2B48C", text: "#000000" },
      { name: "Bleu marine", code: "#0B1C2D", text: "#ffffff" },
    ],
    featured: false,
  },
];